'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes');
var _ = require('underscore');
var CheckBoxItem = require('../common/CheckBoxItem');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');

/*
 * 复选框组件
 */
var Checkbox = React.createClass({

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('checkedChange', this._onClick);
  },

  componentWillReceiveProps: function (newProps) {
    var newChecked = appTypes.ComStatus.isSelected(newProps.state);
    var newDisabled = appTypes.ComStatus.isDisabled(newProps.state);
    if (newChecked !== this.state.checked || newDisabled !== this.state.disabled){
      this.setState({checked: newChecked, disabled: newDisabled})
    }
  },

  getInitialState: function () {
    return {
      checked: appTypes.ComStatus.isSelected(this.props.state),
      disabled: appTypes.ComStatus.isDisabled(this.props.state)
    };
  },

  render: function () {
    var state = styleHelper.getPropertyValue(this.props,propConst.STATE);
    var props = _.extend({}, this.props);
    props.isChecked = this.state.checked;
    props.isDisabled = this.state.disabled;
    props.onChecked = this._onChecked;
    props.text = styleHelper.getText(this.props);
    if(props.stateProperties){
      props.isChecked = appTypes.ComStatus.isSelected(state);
      props.isDisabled = appTypes.ComStatus.isDisabled(state);
    }

    return (
      <CheckBoxItem {...props}/>
    );
  },

  _onClick: function (e) {
    var arg = arguments;
    var linkKey;
    var evt;
    var data;
    //e.stopPropagation();
    if (arg.length > 1) {
      data = arg[1];
      linkKey = data.key;
      evt = data.nativeEvent;
    }
    if (!this.state.disabled) {
      this.props.events.doSelfChecked(evt, this.props, !this.state.checked, linkKey);
      this._onChecked(0, !this.state.checked);
    }
  },

  _onChecked: function (index, isChecked) {
    if (!this.state.disabled) {
      this.setState({
        checked: isChecked
      });
    }
  }

});

module.exports = Checkbox;



// WEBPACK FOOTER //
// ./src/views/Components/Checkbox.jsx